import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.list = {
      background: 'lightGray',
      gridTemplateColumns: '1fr',
      justifyItems: 'flex-start',
      gridGap: 11,
      px: 8,
      py: '32px',
    };

    this.item = {
      display: 'block',
      variant: 'text.lg',
    };

    this.link = {
      position: 'relative',
      display: 'inline',
      fontSize: '16px',
      lineHeight: '22px',
      letterSpacing: '0.32px',
      pb: 1,
      backgroundImage: 'linear-gradient(currentColor, currentColor)',
      backgroundPosition: '0% 100%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '0% 1px',
      transition: 'background-size 0.2s ease-in-out',
      ':hover, :focus': {
        backgroundSize: '100% 1px',
      },
    };
  })()
);
